define( function() {
	"use strict";

	return window.document;
} );



//////////////////
// WEBPACK FOOTER
// /srv/_versions/easypost-web/easypost-web-201703161753-430ad182f9-master/~/jquery/src/var/document.js
// module id = 16
// module chunks = 1